export const DEFAULT_PRIZE_POOL_LOGO = '/imgs/campaign/cup.svg';

export const PRIZE_POOL_ICONS = [
  '/imgs/campaign/goals.svg',
  '/imgs/campaign/rocket.svg',
  '/imgs/campaign/fire.svg',
  '/imgs/campaign/diamond.svg',
  '/imgs/campaign/crown.svg',
];
